import { createQueryKeys } from "@lukemorales/query-key-factory";
import { GetTeamRequest, GetTeamsRequest } from "@/Stub/V1";

export const Teams = createQueryKeys('teams', {
    list: (requestParams?: GetTeamsRequest) => [{ requestParams }],
    detail: (requestParams?: GetTeamRequest) => [{ requestParams }],
});